import React, { useState, useRef, useEffect } from "react";
// import { Dropdown } from 'react-bootstrap';
import { IoChevronBackCircleOutline } from "react-icons/io5";
import {
  IoMdArrowDropdown,
  IoMdArrowDropright,
  IoMdCalendar,
} from "react-icons/io";
import { PiListFill } from "react-icons/pi";
import { FaArrowRightArrowLeft, FaCrown } from "react-icons/fa6";
import { BsInfoCircle, BsInfoCircleFill, BsStars } from "react-icons/bs";
import { ImInfinite } from "react-icons/im";
import PlanCard from "./Component/PlanCard";
import PlanCardTwo from "./Component/PlanCardTwo";
import Australia from "../../../assets/img/mapicons/Australia.png";
import Asia from "../../../assets/img/mapicons/Asia.png";
import Africa from "../../../assets/img/mapicons/Africa.png";
import Balkans from "../../../assets/img/mapicons/Balkans.png";
import Caribbean from "../../../assets/img/mapicons/Caribbean.png";
import Caucasus from "../../../assets/img/mapicons/Caucasus.png";
import LatinAmerica from "../../../assets/img/mapicons/LatinAmerica.png";
import MiddleEast from "../../../assets/img/mapicons/MiddleEast.png";
import World from "../../../assets/img/mapicons/World.png";
import t20WcIcon from "../../../assets/img/mapicons/t20-wc-icon.jpg";
import PlansBasedOnCountryService from "../../../Services/PlansBasedOnCountryService";
import {
  CALLS_AND_SMS,
  DATA_CALLS_SMS,
  DATA_ONLY,
} from "../../../Common/Constant";
import PlansBasedOnRegionService from "../../../Services/PlansBasedOnRegionService ";
import GlobalPlansService from "../../../Services/GlobalPlansService";
import ComingSoon from "../../Common/ComingSoon";
import { LuArrowDownUp } from "react-icons/lu";
import { MdCall } from "react-icons/md";
import { BiMessageDetail } from "react-icons/bi";
import mini_icon from "../../../assets/img/mapicons/global_icon/mini.jpg";
import std_icon from "../../../assets/img/mapicons/global_icon/std.jpg";
import full_icon from "../../../assets/img/mapicons/global_icon/full.jpg";
import large_icon from "../../../assets/img/mapicons/global_icon/large.jpg";
import Loader from "../../Alert_Popup/Loader";
import MicroLoader from "../../Alert_Popup/MicroLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "../../../scss/flag-sprite.css";
import { useTheme } from "../../Common/Theme/ThemeProvider";
const PlansTray = ({
  data,
  setShowPlansTray,
  planType,
  selected,
  tab,
  recurringModal,
  setRecurringModal,
  setModalData,
  openCoverageDropdownForGlobal,
  globalCountries,
  setCurrentDetails,
  setDetailsOpen,
  setSubPlan,
  subPlan,
  hideBack,
  setShoweKycPopup,
  isTopPlan,
  vendorId,
  resetTheFilterValue,
  setResetTheFilterValue,
}) => {
  // const [selected, setSelected] = useState("All");
  const { theme, toggleTheme } = useTheme();
  const [planSelectedOption, setPlanSelectedOption] = useState(0);
  const [planTypeSelectedOption, setPlanTypeSelectedOption] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [dataPlan, setDataPlan] = useState([]);
  const [dataCallSMSPlan, setDataCallSMSPlan] = useState([]);
  const [callSMSPlan, setCallSMSPlan] = useState([]);
  const [originalDataPlan, setOriginalDataPlan] = useState([]);
  const [originalDataCallSMSPlan, setOriginalDataCallSMSPlan] = useState([]);
  const [originalCallSMSPlan, setOriginalCallSMSPlan] = useState([]);
  const [message, setMessage] = useState();
  const [statusCode, setStatusCode] = useState();
  const [isDataOptionOpen, setIsDataOptionOpen] = useState(false);
  const [dataPlanSelectedOption, setDataPlanSelectedOption] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [isDaysOptionOpen, setIsDaysOptionOpen] = useState(false);
  const [daysPlanSelectedOption, setDaysPlanSelectedOption] = useState(0);
  const buttonRef = useRef();
  const divRef = useRef();

  const dataFilterbuttonRef = useRef();
  const dataFilterDivRef = useRef();

  const daysFilterbuttonRef = useRef();
  const daysFilterDivRef = useRef();
  const history = useHistory();

  useEffect(() => {
    if (dataPlanSelectedOption == 0 && daysPlanSelectedOption == 0) {
      setResetTheFilterValue(false);
    }
  }, [dataPlanSelectedOption, daysPlanSelectedOption]);

  useEffect(() => {
    if (resetTheFilterValue == true) {
      setDataPlanSelectedOption(0);
      setDaysPlanSelectedOption(0);
    } else {
    }
  }, [resetTheFilterValue, dataPlanSelectedOption, daysPlanSelectedOption]);

  const planFilterOptions = [
    {
      index: 0,
      label: "Data Plans",
      icons: [<FaArrowRightArrowLeft style={{ transform: "rotate(90deg)" }} />],
    },
    {
      index: 1,
      label: "Hybrid Plans",
      icons: [
        <FaArrowRightArrowLeft style={{ transform: "rotate(90deg)" }} />,
        <MdCall />,
        <BiMessageDetail />,
      ],
    },
    {
      index: 2,
      label: "Minutes & Text Plans",
      icons: [<MdCall />, <BiMessageDetail />],
    },
  ];
  const planTypeOptions = [
    { index: 0, label: "All Plans", icon: <PiListFill /> },
    { index: 1, label: "Popular Plans", icon: <BsStars /> },
    { index: 2, label: "Unlimited Plans", icon: <ImInfinite /> },
    { index: 3, label: "Premium Plans", icon: <FaCrown /> },
  ];
  const [validityList, setValidityList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);

  const [dataPlanOptions, setDataPlanOptions] = useState({
    label: [],
    icon: <FaArrowRightArrowLeft style={{ transform: "rotate(90deg)" }} />,
  });
  const [dayPlanOptions, setDayPlanOptions] = useState({
    label: [],
    icon: <IoMdCalendar />,
  });

  useEffect(() => {
    if (originalDataPlan?.length > 0) {
      const extractedValidity = originalDataPlan.map((plan) => plan.validity);
      const extractedData = originalDataPlan.map((plan) => plan.data);

      // Sorting Validity
      const sortedValidity = [...new Set(extractedValidity)]
        .map(Number)
        .sort((a, b) => a - b)
        .map((val) => `${val} ${val === 1 ? "Day" : "Days"}`);

      // Sorting Data
      var sortedData = [...new Set(extractedData)].sort((a, b) => {
        const convertToMB = (value) => {
          // if (value === 'All') return -Infinity;  // Lowest priority
          if (value === "Unlimited") return Infinity; // Highest priority

          const num = parseFloat(value);
          return value.includes("GB") ? num * 1000 : num; // Convert GB to MB
        };

        return convertToMB(a) - convertToMB(b);
      });
      setValidityList(sortedValidity);
      setDataList(sortedData);

      setDataPlanOptions((prev) => ({
        ...prev,
        label: ["All", ...sortedData],
      }));

      setDayPlanOptions((prev) => ({
        ...prev,
        label: ["All", ...sortedValidity],
      }));
    }
  }, [originalDataPlan]);

  // const dataPlanOptions = {
  //   label: [
  //     "All Data",
  //     "5GB",
  //     "10GB",
  //     "30GB",
  //     "40GB",
  //     "60GB",
  //     "90GB",
  //     "100GB",
  //     "120GB",
  //     "150GB",
  //     "200GB",
  //   ],
  //   icon: <FaArrowRightArrowLeft style={{ transform: "rotate(90deg)" }} />,
  // };
  // const dayPlanOptions = {
  //   label: [
  //     "All Days",
  //     "7 Days",
  //     "30 Days",
  //     "60 Days",
  //     "90 Days",
  //     "120 Days",
  //     "365 Days",
  //   ],
  //   icon: <IoMdCalendar />,
  // };

  // [
  //   { index: 0, label: "All Plans", icon: <PiListFill /> },
  //   { index: 1, label: "Popular Plans", icon: <BsStars /> },
  //   { index: 2, label: "Unlimited Plans", icon: <ImInfinite /> },
  //   { index: 3, label: "Premium Plans", icon: <FaCrown /> },
  // ];

  const handleButtonClick = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };
  const handleOutsideClick = (event) => {
    if (
      buttonRef.current &&
      !buttonRef.current.contains(event.target) &&
      divRef.current &&
      !divRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  const handleDataFilterButtonClick = () => {
    setIsDataOptionOpen((isDataOptionOpen) => !isDataOptionOpen);
  };
  const handleDataFilterOutsideClick = (event) => {
    if (
      dataFilterbuttonRef.current &&
      !dataFilterbuttonRef.current.contains(event.target) &&
      dataFilterDivRef.current &&
      !dataFilterDivRef.current.contains(event.target)
    ) {
      setIsDataOptionOpen(false);
    }
  };

  const handleDaysFilterButtonClick = () => {
    setIsDaysOptionOpen((isDaysOptionOpen) => !isDaysOptionOpen);
  };
  const handleDaysFilterOutsideClick = (event) => {
    if (
      daysFilterbuttonRef.current &&
      !daysFilterbuttonRef.current.contains(event.target) &&
      daysFilterDivRef.current &&
      !daysFilterDivRef.current.contains(event.target)
    ) {
      setIsDaysOptionOpen(false);
    }
  };

  const plansAPI = async () => {
    setIsLoading(true);
    await PlansBasedOnCountryService.counrtyPlan(selected.alpha2)
      .then((response) => {
        if (response.status === 200) {
          let resp = response.data;
          setDataPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_ONLY &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalDataPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_ONLY &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setDataCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_CALLS_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalDataCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_CALLS_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == CALLS_AND_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == CALLS_AND_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.message === "Network Error") {
          setMessage("Something went wrong, Please try again later");
        } else {
          setMessage(error.response.data.failedReason);
          setStatusCode(error.response ? error.response.status : "");
        }
      });
  };

  const regionalPlansAPI = async () => {
    setIsLoading(true);
    await PlansBasedOnRegionService.regionPlan(selected.regionId)
      .then((response) => {
        if (response.status === 200) {
          let resp = response.data;
          setDataPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_ONLY &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalDataPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_ONLY &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setDataCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_CALLS_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalDataCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_CALLS_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == CALLS_AND_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == CALLS_AND_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.message === "Network Error") {
          // setIsLoading(false);
          setMessage("Something went wrong, Please try again later");
        } else {
          setMessage(error.response.data.failedReason);
          setStatusCode(error.response ? error.response.status : "");
        }
      });
  };
  const globalPlans = async () => {
    setIsLoading(true);
    await GlobalPlansService.globalPopularPlanByCategory(
      selected.globalCategoryId
    )
      .then((response) => {
        if (response.status === 200) {
          let resp = response.data;
          setDataPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_ONLY &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalDataPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_ONLY &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setDataCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_CALLS_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalDataCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == DATA_CALLS_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == CALLS_AND_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
          setOriginalCallSMSPlan(
            resp
              .filter(
                (c) =>
                  c.planCategory.planCategoryId == CALLS_AND_SMS &&
                  (isTopPlan ? c.vendor.vendorId == vendorId : true)
              )
              .map((item, index) => ({
                ...item,
                isPopularIndex: index < 3 ? true : false,
                itemIndex: index,
              }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.message === "Network Error") {
          // setIsLoading(false);
          setMessage("Something went wrong, Please try again later");
        } else {
          setMessage(error.response.data.failedReason);
          setStatusCode(error.response ? error.response.status : "");
        }
      });
  };

  const getFilterListByPlanType = (input) => {
    var dataPlanList = originalDataPlan;
    var dataCallSMSPlanList = originalDataCallSMSPlan;
    var callSMSPlanList = originalCallSMSPlan;
    if (input == 0) {
      setDataPlanSelectedOption(0);
      setDaysPlanSelectedOption(0);
      //all
      setDataPlan(dataPlanList);
      setDataCallSMSPlan(dataCallSMSPlanList);
      setCallSMSPlan(callSMSPlanList);
    }
    if (input == 1) {
      //popular
      setDataPlan(dataPlanList.filter((c) => c.isPopularIndex));
      setDataCallSMSPlan(dataCallSMSPlanList.filter((c) => c.isPopularIndex));
      setCallSMSPlan(callSMSPlanList.filter((c) => c.isPopularIndex));
    }
    if (input == 2) {
      //unlimited
      setDataPlan(dataPlanList.filter((c) => c.unlimitedPlan === true));
      setDataCallSMSPlan(
        dataCallSMSPlanList.filter((c) => c.unlimitedPlan === true)
      );
      setCallSMSPlan(callSMSPlanList.filter((c) => c.unlimitedPlan === true));
    }
    if (input == 3) {
      //premium
      const top3DataPlanPrices = dataPlanList
        .map((plan) => plan.price) // Extract prices
        .sort((a, b) => b - a) // Sort descending
        .slice(0, 3);
      const top3HybridPlanPrices = dataCallSMSPlanList
        .map((plan) => plan.price) // Extract prices
        .sort((a, b) => b - a) // Sort descending
        .slice(0, 3);
      const top3CallSMSPlanPrices = callSMSPlanList
        .map((plan) => plan.price) // Extract prices
        .sort((a, b) => b - a) // Sort descending
        .slice(0, 3);
      setDataPlan(
        dataPlanList.filter((plan) => top3DataPlanPrices.includes(plan.price))
      );
      setDataCallSMSPlan(
        dataCallSMSPlanList.filter((plan) =>
          top3HybridPlanPrices.includes(plan.price)
        )
      );
      setCallSMSPlan(
        callSMSPlanList.filter((plan) =>
          top3CallSMSPlanPrices.includes(plan.price)
        )
      );
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("click", handleDataFilterOutsideClick);
    document.addEventListener("click", handleDaysFilterOutsideClick);

    if (tab == 1) {
      plansAPI();
    }
    if (tab == 2) {
      regionalPlansAPI();
    }
    if (tab == 3) {
      globalPlans();
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [tab, selected]);

  useEffect(() => {
    var dataPlanList = originalDataPlan;
    if (planSelectedOption == 0 && planTypeSelectedOption == 0) {
      setDataPlan(
        dataPlanList.filter((e) => {
          const isAllData =
            dataPlanOptions.label[dataPlanSelectedOption] === "All";
          const isAllDays =
            dayPlanOptions.label[daysPlanSelectedOption] === "All";

          const matchesData =
            isAllData ||
            e.data === dataPlanOptions.label[dataPlanSelectedOption];
          const matchesDays =
            isAllDays ||
            `${e.validity} ${e.validity == 1 ? "Day" : "Days"}` ===
            dayPlanOptions.label[daysPlanSelectedOption];

          return matchesData && matchesDays;
        })
      );
    }
  }, [planSelectedOption, dataPlanSelectedOption, daysPlanSelectedOption]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center plans-tray notranslate">
      {/* first line */}
      <div className="w-100 d-flex justify-content-between align-items-center flex-wrap mb-3">
        <div
          style={{ maxWidth: "180px", gap: "4px" }}
          className="d-flex justify-content-start align-items-center"
        >
          {hideBack && hideBack == true ? null : (
            <div style={{ width: "42px", height: "42px" }}>
              <IoChevronBackCircleOutline
                style={{
                  fontSize: "42px",
                  width: "42px",
                  height: "42px",
                  color: "rgb(222, 222, 222)",
                }}
                className=""
                onClick={() => setShowPlansTray(false)}
              />
            </div>
          )}
          <div>
            {tab == 1 && (
              <div
                onClick={() =>
                  history.push(`/plan-details/alpha2/${selected.alpha2}`)
                }
                className={`grid-card country-info-tag`} style={{ maxWidth: "165px" }}
              >
                <div>
                  <span
                    className={`fflag fflag-${selected.alpha2} ff-lg ff-round`}
                  ></span>
                </div>
                <div className="grid-tray" style={{ overflow: "hidden" }}>
                  <p className="m-0">{selected.countryDescription}</p>
                </div>
                <div>
                  <BsInfoCircleFill />
                </div>
              </div>
            )}
            {tab == 2 && (
              <div
                onClick={() =>
                  history.push(`/plan-details/regionId/${selected.regionId}`)
                }
                className={`grid-card country-info-tag`} style={{ maxWidth: "165px" }}
              >
                <div>
                  <span
                    className={`${selected.regionDescription == "Europe" ? "fflag-EU" : ""
                      } fflag ff-lg ff-round`}
                  >
                    {selected.regionDescription != "Europe" ? (
                      <img
                        className="regionLogo"
                        src={
                          selected.regionDescription == "Africa"
                            ? Africa
                            : selected.regionDescription == "Asia"
                              ? Asia
                              : selected.regionDescription == "Australia"
                                ? Australia
                                : selected.regionDescription == "Caribbean"
                                  ? Caribbean
                                  : selected.regionDescription == "Latin America"
                                    ? LatinAmerica
                                    : selected.regionDescription == "Balkans"
                                      ? Balkans
                                      : selected.regionDescription == "Caucasus"
                                        ? Caucasus
                                        : selected.regionDescription == "Middle East"
                                          ? MiddleEast
                                          : selected.regionDescription == "T20 WC Region 1"
                                            ? t20WcIcon
                                            : selected.regionDescription == "T20 WC Region 2"
                                              ? t20WcIcon
                                              : World
                        }
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </div>
                <div className="grid-tray" style={{ overflow: "hidden" }}>
                  <p className="">{selected.regionDescription}</p>
                </div>
                <div>
                  <BsInfoCircleFill />
                </div>
              </div>
            )}
            {tab == 3 && (
              <div className="grid-card global-card" style={{ maxWidth: "165px" }}>
                <div>
                  <span className={`fflag ff-lg ff-round`}>
                    <img
                      className="regionLogo"
                      src={
                        selected.globalCategoryId === 1
                          ? mini_icon
                          : selected.globalCategoryId === 2
                            ? std_icon
                            : selected.globalCategoryId === 3
                              ? large_icon
                              : selected.globalCategoryId === 4
                                ? full_icon
                                : null
                      }
                    />
                  </span>
                </div>
                <div className="grid-tray" style={{ overflow: "hidden" }}>
                  <p className="">{selected.globalCategoryDescription}</p>
                </div>
              </div>
            )}
          </div>
          {/* {planType == "global" && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => openCoverageDropdownForGlobal(true)}
              class="countries-label-dropdown d-flex justify-content-start align-items-center ml-2"
            >
              <span>{globalCountries?.length} Countries</span>
              <IoMdArrowDropdown />
            </div>
          )} */}
        </div>
        <div className="w-100 plantype-options-grid-one mx-auto">
          {planFilterOptions.map((item, index) => (
            <button
              key={index}
              onClick={() => setPlanSelectedOption(item.index)}
              className={` btn btn-sm shadow-sm rounded-pill d-flex justify-content-start align-items-center ${index === planSelectedOption
                  ? "btn-custom-gradient"
                  : theme === "light" ? "btn-outline-dark" : "btn-outline-light"
                } plan-filter-btn`}
            >
              <span
                className="d-flex align-items-center "
                style={{ gap: "4px" }}
              >
                {item.icons}
              </span>
              {item.label}
            </button>
          ))}
        </div>
        <div style={{ maxWidth: "190px" }}>
          <div className="">
            <button
              ref={buttonRef}
              onClick={handleButtonClick}
              className="plan-filter-btn notranslate btn-custom-gradient shadow-sm w-100"
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  color: "#fff",
                }}
                className="mb-0"
                htmlFor=""
              >
                {planTypeOptions[planTypeSelectedOption].icon}
                {planTypeOptions[planTypeSelectedOption].label}
              </span>
              <IoMdArrowDropdown style={{ color: "#fff", marginLeft: "6px" }} />
            </button>
            {isOpen && (
              <div
                ref={divRef}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
                className="plan-filter-btn-tray-section"
              >
                {planTypeOptions.map((item, index) => (
                  <span
                    key={index}
                    onClick={() => {
                      setPlanTypeSelectedOption(item.index);
                      setIsOpen(false);
                      getFilterListByPlanType(item.index);
                    }}
                    className="plan-filter-span mb-0"
                  >
                    {item.icon} {item.label}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* first line */}
      {/* Second line */}
      <div className="w-100 plantype-options-grid-two">
        {planFilterOptions.map((item, index) => (
          <button
            key={index}
            onClick={() => setPlanSelectedOption(item.index)}
            className={` btn btn-sm shadow-sm rounded-pill d-flex justify-content-start align-items-center ${index === planSelectedOption
                ? "btn-custom-gradient"
                : theme === "light" ? "btn-outline-dark" : "btn-outline-light"
              } plan-filter-btn`}
          >
            <span className="d-flex align-items-center " style={{ gap: "4px" }}>
              {item.icons}
            </span>
            {item.label}
          </button>
        ))}
      </div>
      {/* Second line */}
      {/* Third Line */}
      {planTypeSelectedOption == 0 &&
        planSelectedOption == 0 &&
        (dataPlanOptions.label.length > 0 ||
          dayPlanOptions.label.length > 0) && (
          <div className="w-100 mt-3 d-md-none first-filter-container">
            <div className="">
              <button
                ref={dataFilterbuttonRef}
                onClick={handleDataFilterButtonClick}
                className="plan-filter-btn notranslate btn-custom-gradient shadow-sm w-100"
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    color: "#fff",
                  }}
                  className="mb-0"
                  htmlFor=""
                >
                  {dataPlanOptions.icon}
                  {dataPlanOptions.label[dataPlanSelectedOption]}
                </span>
                <IoMdArrowDropdown
                  style={{ color: "#fff", marginLeft: "6px" }}
                />
              </button>
              {isDataOptionOpen && (
                <div
                  ref={dataFilterDivRef}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    left: 5,
                    right: "auto",
                    minWidth: "150px",
                    maxHeight: "270px",
                    overflowY: "auto",
                  }}
                  className="plan-filter-btn-tray-section"
                >
                  {dataPlanOptions.label.map((item, index) => (
                    <span
                      key={index}
                      onClick={() => {
                        setDataPlanSelectedOption(index);
                        setIsDataOptionOpen(false);
                      }}
                      className="plan-filter-span mb-0"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="">
              <button
                ref={daysFilterbuttonRef}
                onClick={handleDaysFilterButtonClick}
                className="plan-filter-btn notranslate btn-custom-gradient shadow-sm w-100"
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    color: "#fff",
                  }}
                  className="mb-0"
                  htmlFor=""
                >
                  {dayPlanOptions.icon}
                  {dayPlanOptions.label[daysPlanSelectedOption]}
                </span>
                <IoMdArrowDropdown
                  style={{ color: "#fff", marginLeft: "6px" }}
                />
              </button>
              {isDaysOptionOpen && (
                <div
                  ref={daysFilterDivRef}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    left: "auto",
                    right: 0,
                    minWidth: "150px",
                    maxHeight: "270px",
                    overflowY: "auto",
                  }}
                  className="plan-filter-btn-tray-section"
                >
                  {dayPlanOptions.label.map((item, index) => (
                    <span
                      key={index}
                      onClick={() => {
                        setDaysPlanSelectedOption(index);
                        setIsDaysOptionOpen(false);
                      }}
                      className="plan-filter-span mb-0"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      {planTypeSelectedOption == 0 &&
        planSelectedOption == 0 &&
        (dataPlanOptions.label.length > 0 ||
          dayPlanOptions.label.length > 0) && (
          <div className="w-100 d-none d-md-flex second-filter-container">
            <div className="second-filter-data-button">
              <button
                style={{
                  minWidth: "auto",
                  border: "1px solid #808080",
                  pointerEvents: "none",
                  width: "120px",
                  backgroundColor: "#808080",
                  height: "38px",
                  margin: "5px 0",
                  color: "#fff",
                  justifyContent: "space-between",
                }}
                className="grid-card"
              >
                <div className="d-flex align-items-center" style={{ gap: 5 }}>
                  <FaArrowRightArrowLeft
                    style={{ transform: "rotate(90deg)" }}
                  />
                  <span>Data</span>
                </div>
                <IoMdArrowDropright />
              </button>
              {dataPlanOptions.label.map((item, index) => (
                <button
                  onClick={() => setDataPlanSelectedOption(index)}
                  style={{ minWidth: "auto" }}
                  className={`${dataPlanSelectedOption == index ? "btn-custom-gradient" : ""
                    } btn btn-sm shadow-sm rounded-pill d-flex justify-content-start align-items-center rounded-pill ${theme === "light" ? "btn-outline-dark" : "btn-outline-light"} plan-filter-btn`}
                >
                  {item}
                </button>
              ))}
            </div>
            <div className="second-filter-data-button">
              <button
                style={{
                  minWidth: "auto",
                  border: "1px solid rgba(188, 188, 188, 0.5)",
                  pointerEvents: "none",
                  width: "120px",
                  backgroundColor: "rgba(188, 188, 188, 0.5)",
                  height: "38px",
                  margin: "5px 0",
                  color: "#fff",
                  justifyContent: "space-between",
                }}
                className="grid-card"
              >
                <div className="d-flex align-items-center" style={{ gap: 5 }}>
                  <IoMdCalendar />
                  <span>Validity</span>
                </div>
                <IoMdArrowDropright />
              </button>
              {dayPlanOptions.label.map((item, index) => (
                <button
                  onClick={() => setDaysPlanSelectedOption(index)}
                  style={{ minWidth: "auto" }}
                  className={`${daysPlanSelectedOption == index ? "btn-custom-gradient" : ""
                    } btn btn-sm shadow-sm rounded-pill d-flex justify-content-start align-items-center rounded-pill ${theme === "light" ? "btn-outline-dark" : "btn-outline-light"} plan-filter-btn`}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>
        )}
      {/* Third line */}

      <div
        style={{ minHeight: "180px" }}
        className="w-100 my-4 plans-grid-container position-relative"
      >
        {planSelectedOption == 0 ? (
          isLoading ? (
            <>
              <div></div>
              <div
                className="w-100 d-flex justify-content-center align-items-center"
                style={{
                  height: "250px",
                }}
              >
                <MicroLoader />
              </div>
              <div></div>
            </>
          ) : dataPlan.length > 0 ? (
            [...dataPlan].map((item, index) => (
              <PlanCard
                key={index}
                data={item}
                recurringModal={recurringModal}
                setRecurringModal={setRecurringModal}
                setModalData={setModalData}
                setCurrentDetails={setCurrentDetails}
                setDetailsOpen={setDetailsOpen}
                setSubPlan={setSubPlan}
                subPlan={subPlan}
                isTopPlan={isTopPlan}
                vendorId={vendorId}
              />
            ))
          ) : (
            <ComingSoon />
          )
        ) : planSelectedOption == 1 ? (
          isLoading ? (
            <>
              <div></div>
              <div
                className="w-100 d-flex justify-content-center align-items-center"
                style={{
                  height: "250px",
                }}
              >
                <MicroLoader />
              </div>
              <div></div>
            </>
          ) : dataCallSMSPlan.length > 0 ? (
            [...dataCallSMSPlan].map((item, index) => (
              <PlanCardTwo
                key={index}
                data={item}
                recurringModal={recurringModal}
                setRecurringModal={setRecurringModal}
                setModalData={setModalData}
                setCurrentDetails={setCurrentDetails}
                setDetailsOpen={setDetailsOpen}
                setSubPlan={setSubPlan}
                subPlan={subPlan}
                setShoweKycPopup={setShoweKycPopup}
                isTopPlan={isTopPlan}
                vendorId={vendorId}
              />
            ))
          ) : (
            <ComingSoon />
          )
        ) : planSelectedOption == 2 ? (
          isLoading ? (
            <>
              <div></div>
              <div
                className="w-100 d-flex justify-content-center align-items-center"
                style={{
                  height: "250px",
                }}
              >
                <MicroLoader />
              </div>
              <div></div>
            </>
          ) : callSMSPlan.length > 0 ? (
            [...callSMSPlan].map((item, index) => (
              <PlanCardTwo
                key={index}
                data={item}
                recurringModal={recurringModal}
                setRecurringModal={setRecurringModal}
                setModalData={setModalData}
                setCurrentDetails={setCurrentDetails}
                setDetailsOpen={setDetailsOpen}
                setSubPlan={setSubPlan}
                subPlan={subPlan}
                vendorId={vendorId}
                setShoweKycPopup={setShoweKycPopup}
              />
            ))
          ) : (
            <ComingSoon />
          )
        ) : null}
      </div>
    </div>
  );
};

export default PlansTray;
